import { render, staticRenderFns } from "./EditSubjectEditor.vue?vue&type=template&id=292cc271&"
import script from "./EditSubjectEditor.vue?vue&type=script&lang=js&"
export * from "./EditSubjectEditor.vue?vue&type=script&lang=js&"
import style0 from "./EditSubjectEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports